export class Material{
    idMaterial: string;
    description: string;
    materialCode: string;
}